import { render, staticRenderFns } from "./SavedFiltersMenu.vue?vue&type=template&id=7515c42e&scoped=true"
import script from "./SavedFiltersMenu.vue?vue&type=script&lang=js"
export * from "./SavedFiltersMenu.vue?vue&type=script&lang=js"
import style0 from "./SavedFiltersMenu.vue?vue&type=style&index=0&id=7515c42e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7515c42e",
  null
  
)

export default component.exports